import { BillNotificationType } from "@boo/shared";
import type { BillNotification } from "@boo/shared";

/** One-line summary of an owner-side notification for the bell list. */
export function ownerNotificationText(n: BillNotification): string {
  const who = n.payload.personName ?? "A friend";
  switch (n.type) {
    case BillNotificationType.FriendReviewed:
      return `${who} confirmed their share`;
    case BillNotificationType.FriendFlagged:
      return `${who} flagged "${n.payload.itemName ?? "a line"}"`;
    case BillNotificationType.ReadyToFinalize:
      return "Everyone confirmed their share — ready to finalize";
    case BillNotificationType.SlipNeedsDecision:
      return `${who} sent a slip to check`;
    case BillNotificationType.FriendPaid:
      return `${who} paid ฿${n.payload.amount ?? 0}`;
    default:
      return "Bill updated";
  }
}
